<!-- components/modals/BringFromBrokerModal.vue -->
<template>
  <div id="depositModal" class="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4 hidden">
    <div class="bg-[#0C1020] w-full max-w-md rounded-2xl p-6 shadow-2xl border border-[#d600c0] relative text-white">
      <!-- Botão de fechar -->
      <button
        class="absolute top-3 right-3 text-white hover:text-[#d600c0] transition-colors text-xl z-10"
        aria-label="Fechar modal"
        @click="close"
      >
        &times;
      </button>

      <!-- Conteúdo -->
      <h2 class="text-white text-2xl font-semibold mb-4 text-center">Trazer da Corretora</h2>

      <div class="space-y-4">
        <div>
          <label class="text-gray-400 text-sm mb-1 block">Valor a trazer</label>
          <input
            v-model="valor"
            type="number"
            class="w-full px-4 py-2 rounded-md bg-[#10182C] border border-[#2D3A5C] text-white"
            placeholder="Ex: 500"
          />
        </div>

        <div>
          <label class="text-gray-400 text-sm mb-1 block">Moeda</label>
          <select v-model="moeda" class="w-full px-4 py-2 rounded-md bg-[#10182C] border border-[#2D3A5C] text-white">
            <option value="BRL">BRL</option>
            <option value="USDT">USDT</option>
          </select>
          <small v-if="moeda === 'BRL'">Cotação dolar: {{ taxFormatado }}</small>
        </div>

        <VaButton class="w-full mt-4 font-semibold" color="#d600c0" @click="confirmar"> Confirmar </VaButton>

        <p v-if="mensagem" class="text-center text-sm text-[#d600c0] mt-2">{{ mensagem }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useAppStore } from '../../stores/integration'
import { useToast } from 'vuestic-ui'

const { deposit, getTaxDolar } = useAppStore()
const { init } = useToast()

const valor = ref(0)
const moeda = ref('BRL')
const mensagem = ref('')
const tax = ref(0)
const getTax = async () => {
  tax.value = await getTaxDolar(false)
}
const close = () => {
  document.getElementById('depositModal')?.classList.add('hidden')
  valor.value = 0
  mensagem.value = ''
}

const confirmar = async () => {
  if (!valor.value || Number(valor.value) <= 0) {
    mensagem.value = 'Informe um valor válido.'
    return
  }

  const res = await deposit(valor.value, moeda.value.toLowerCase())

  if (res.success) {
    mensagem.value = ''
    init({ message: res.message, color: 'success' })
    close()
  } else {
    mensagem.value = res.message
  }
}
const taxFormatado = computed(() =>
  Number(tax.value || 0).toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
  }),
)

onMounted(() => {
  getTax()
})
</script>
